// searchReducer.js
import {
    FAQ_SEARCH_REQUEST,
    FAQ_SEARCH_SUCCESS,
    FAQ_SEARCH_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    results: [],
    error: null,
};

const faqsearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case FAQ_SEARCH_REQUEST:
            return {
                ...state,
                loading: true,
                results: [],
                error: null,
            };
        case FAQ_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                results: action.payload,
            };
        case FAQ_SEARCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default faqsearchReducer;
